// 成績表の明細全体をリンクにする
$(document).on('turbolinks:load', function () {
  $('td[data-href]').on('click', function() {
    window.location = $(this).data('href');
  });
});
